import styled from "@emotion/styled";
import React, { ReactElement, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: string;
  onCloseButtonClick?: () => void;
  onBackButtonClick?: () => void;
  navigatorContent?: ReactElement;
  headerContent?: ReactElement;
  footerContent?: ReactElement;
  id?: string;
  testId?: string;
}>

const Backdrop = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  height: 100%;
  background: white;
  overflow: hidden;

  @media screen and (min-width: 482px) {
    width:  544px;
    height: 45.5rem;
    border-radius: .5rem;
  }
`;

const Header = styled.header`
  display: flex;
  flex-flow: column nowrap;
  padding: 1rem;
  height: 3.5rem;
`;

const Navigation = styled.nav`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
`;

const NavigationButton = styled.button`
  width: 1.5rem;
  height: 1.5rem;
  border: 0;
  border-radius: .125rem;
  outline: 0;
  margin: 0;
  padding: 0;
  cursor: pointer;
  background: transparent;
  line-height: 0;

  & img {
    width: 1rem;
    height: 1rem;
  }

  &:focus {
    box-shadow: 0 0 0 .25rem #F2D0E2;
  }
`;

const NavigationPlaceholder = styled.span`
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
`;

const Main = styled.main`
  flex-grow: 1;
  display: flex;
  flex-flow: column nowrap;
  padding: 0 1.5rem;
`;

const Footer = styled.footer`
  display: flex;
  flex: 0 0 0;
  flex-flow: column nowrap;
  padding: 0rem 2rem 1rem 2rem;
`;

const Modal = (props: Props) => {
  return (
    <Backdrop
      className={props.className}
      id={props.id}
      data-testid={props.testId && `${props.testId}-backdrop`}
    >
      <Container data-test-id={props.testId}>
        <Header>
          <Navigation>
            {props.onBackButtonClick ? (
              <NavigationButton
                id={props.id && `${props.id}-back`}
                data-testid={props.testId && `${props.testId}-back-button`}
                onClick={props.onBackButtonClick}
              >
                <img
                  alt="Modal back button icon"
                  src="/assets/back.png"
                />
              </NavigationButton>
            ): <NavigationPlaceholder />}
            {props.navigatorContent ? props.navigatorContent : <span />}
            {props.onCloseButtonClick ? (
              <NavigationButton
                id={props.id && `${props.id}-close`}
                data-testid={props.testId && `${props.testId}-close-button`}
                onClick={props.onCloseButtonClick}
              >
                <img
                  alt="Modal close button icon"
                  src="/assets/close.png"
                />
              </NavigationButton>
            ): <NavigationPlaceholder />}
          </Navigation>
          {props.headerContent}
        </Header>
        <Main>
          {props.children}
        </Main>
        <Footer>
          {props.footerContent}
        </Footer>
      </Container>
    </Backdrop>
  );
};

export default Modal;
